import { QueryResult, useQuery } from '@apollo/client'
import { Country, PyramidPastValueSelectorQuery, PyramidType, QueryPyramidPastValueSelectorArgs } from '../../../types'
import { PAST_PYRAMID_SELECTOR } from '../../pyramids/Queries'

export default (
  companyId: string,
  country: Country,
  pyramidType: PyramidType,
): QueryResult<PyramidPastValueSelectorQuery, QueryPyramidPastValueSelectorArgs> => {
  const variables = {
    companyId: companyId,
    country: country,
    pyramidType: pyramidType,
  }

  return useQuery<PyramidPastValueSelectorQuery, QueryPyramidPastValueSelectorArgs>(PAST_PYRAMID_SELECTOR, {
    variables: variables,
  })
}
